export default __webpack_public_path__ + "static/media/solucao-03.3421f55d.webp";